<div class="radio__container"
     [ngClass]="{'predefined-value': predefinedStyleEnabled, 'radio__container--inline': fieldConfig.radioInline, 'radio__container--tiles': fieldConfig.tilesMode }">

    <div class="radio__text tooltip--reset-top">
        <span class="radio__text__label">{{ fieldConfig.caption | translate }}</span>
        <app-tooltip-icon class="reset-position"
                          *ngIf="tooltipIconVisible"
                          [outlined]="fieldConfig.tooltipIconOutlined"
                          [description]="fieldConfig.description"></app-tooltip-icon>
        <app-information-icon class="information-icon" class="reset-position no-absolute"
                              *ngIf="informationIconVisible"
                              [information]="fieldConfig.predefined.additionalInfo | additionalInfo"
                              [description]="fieldConfig.description | translate">
        </app-information-icon>
    </div>

    <div class="radio__element" [class.radio-error]="errorsMap.get(fieldConfig.fieldKey)">
        <mat-radio-group
                matRadioGroup
                #fieldRadio
                id="{{fieldConfig.fieldKey}}"
                (change)="onChange($event)"
                (click)="onClick($event)"
                [formControl]="control">
            <div *ngIf="fieldConfig.radioConfig; else basicButtons">
                <mat-radio-button *ngFor="let config of fieldConfig.radioConfig"
                                  id="{{fieldConfig.fieldKey + '-' + config.value}}"
                                  [disabled]="config.disabled"
                                  [value]="config.value">
                    {{(config.label) | translate}}
                </mat-radio-button>
            </div>

            <ng-template #basicButtons>
                <mat-radio-button
                        id="{{fieldConfig.fieldKey + '-yes'}}"
                        [value]="true">
                    {{ captionAdditionalTrue | translate }}
                </mat-radio-button>
                <mat-radio-button
                        id="{{fieldConfig.fieldKey + '-no'}}"
                        [value]="false">
                    {{ captionAdditionalFalse | translate }}
                </mat-radio-button>
            </ng-template>
        </mat-radio-group>
        <mat-error *ngIf="errorsMap.get(fieldConfig.fieldKey)" class="radio-error">{{ (context + '.' +
            fieldConfig.fieldKey + '.' +
            errorsMap.get(fieldConfig.fieldKey))|translate}}
        </mat-error>
    </div>
</div>
